import React, { useState } from 'react';
import { useNavigate, useLocation } from 'react-router-dom';
import axios from 'axios';
import { FaRegCheckCircle } from "react-icons/fa";
import { useToast } from '../components/ui/ToastContext';
import { API_URL } from '../config';

function ForgotPassword() {
  const location = useLocation();
  const [username, setUsername] = useState(location.state?.username || '');
  const [oldPassword, setOldPassword] = useState('');
  const [newPassword, setNewPassword] = useState('');
  const [confirmPassword, setConfirmPassword] = useState('');
  const [error, setError] = useState('');
  const [isLoading, setIsLoading] = useState(false);
  const navigate = useNavigate();
  const { showToast } = useToast();

  const handleSubmit = async (e) => {
    e.preventDefault();
    setError('');
    setIsLoading(true);

    if (!username || !oldPassword || !newPassword || !confirmPassword) {
      setError('Toate câmpurile sunt obligatorii');
      setIsLoading(false);
      return;
    }

    if (newPassword !== confirmPassword) {
      setError('Parola nouă și confirmarea parolei nu coincid');
      setIsLoading(false);
      return;
    }

    if (oldPassword === newPassword) {
      setError('Parola nouă trebuie să fie diferită de parola veche');
      setIsLoading(false);
      return;
    }

    try {
      const response = await axios.post(`${API_URL}/api/change-password`, {
        username: username.trim(),
        oldPassword,
        newPassword,
      });

      if (response.status === 200) {
        showToast({
          message: 'Parola a fost schimbată cu succes! Vă puteți autentifica.',
          type: 'success',
          icon: <FaRegCheckCircle className="text-cyan-600 dark:text-cyan-500" />,
        });
        navigate('/');
      }
    } catch (err) {
      console.error('Error changing password:', err.response?.data || err.message);
      
      if (err.response?.data?.error) {
        setError(err.response.data.error);
      } else {
        setError('A apărut o eroare. Vă rugăm să încercați din nou.');
      }
    } finally {
      setIsLoading(false);
    }
  };

  return (
    <div className="flex justify-center items-center h-screen bg-gray-100 dark:bg-gray-900">
      <div className="bg-white dark:bg-gray-800 p-6 rounded-lg shadow-lg max-w-sm w-full">
        <h2 className="text-2xl font-semibold text-gray-800 dark:text-gray-100 mb-4">Schimbare Parolă</h2>
        <form onSubmit={handleSubmit}>
          <div className="mb-4">
            <label
              className="block text-sm font-medium text-gray-700 dark:text-gray-300"
              htmlFor="username"
            >
              Nume utilizator (Login)
            </label>
            <input
              id="username"
              type="text"
              value={username}
              onChange={(e) => setUsername(e.target.value)}
              placeholder="Introduceți username-ul"
              className="mt-1 block w-full px-3 py-2 bg-gray-100 dark:bg-gray-700 border border-gray-300 dark:border-gray-600 rounded-md shadow-sm focus:outline-none focus:ring-blue-500 focus:border-blue-500 sm:text-sm text-gray-900 dark:text-gray-100"
              required
            />
          </div>
          <div className="mb-4">
            <label
              className="block text-sm font-medium text-gray-700 dark:text-gray-300"
              htmlFor="old-password"
            >
              Parola veche / inițială
            </label>
            <input
              id="old-password"
              type="password"
              value={oldPassword}
              onChange={(e) => setOldPassword(e.target.value)}
              placeholder="Introduceți parola veche"
              className="mt-1 block w-full px-3 py-2 bg-gray-100 dark:bg-gray-700 border border-gray-300 dark:border-gray-600 rounded-md shadow-sm focus:outline-none focus:ring-blue-500 focus:border-blue-500 sm:text-sm text-gray-900 dark:text-gray-100"
              required
            />
          </div>
          <div className="mb-4">
            <label
              className="block text-sm font-medium text-gray-700 dark:text-gray-300"
              htmlFor="new-password"
            >
              Parola nouă
            </label>
            <input
              id="new-password"
              type="password"
              value={newPassword}
              onChange={(e) => setNewPassword(e.target.value)}
              placeholder="Introduceți noua parolă"
              className="mt-1 block w-full px-3 py-2 bg-gray-100 dark:bg-gray-700 border border-gray-300 dark:border-gray-600 rounded-md shadow-sm focus:outline-none focus:ring-blue-500 focus:border-blue-500 sm:text-sm text-gray-900 dark:text-gray-100"
              required
            />
          </div>
          <div className="mb-4">
            <label
              className="block text-sm font-medium text-gray-700 dark:text-gray-300"
              htmlFor="confirm-password"
            >
              Confirmare Parolă Nouă
            </label>
            <input
              id="confirm-password"
              type="password"
              value={confirmPassword}
              onChange={(e) => setConfirmPassword(e.target.value)}
              placeholder="Reintroduceți noua parolă"
              className="mt-1 block w-full px-3 py-2 bg-gray-100 dark:bg-gray-700 border border-gray-300 dark:border-gray-600 rounded-md shadow-sm focus:outline-none focus:ring-blue-500 focus:border-blue-500 sm:text-sm text-gray-900 dark:text-gray-100"
              required
            />
          </div>
          {error && <p className="text-red-500 text-sm mb-4">{error}</p>}

          <button
            type="submit"
            disabled={isLoading}
            className={`w-full py-2 px-4 text-white font-semibold rounded-lg shadow-md ${
              isLoading ? 'bg-blue-400' : 'bg-blue-600 hover:bg-blue-700'
            } focus:outline-none focus:ring-2 focus:ring-blue-500 focus:ring-opacity-75`}
          >
            {isLoading ? 'Se procesează...' : 'Schimbă Parola'}
          </button>
        </form>

        <div className="mt-4 text-center">
          <button
            onClick={() => navigate('/')}
            className="text-sm text-blue-600 hover:text-blue-800 focus:outline-none"
          >
            Înapoi la Autentificare
          </button>
        </div>
      </div>
    </div>
  );
}

export default ForgotPassword;